import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, Ref, onUnmounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { Message } from 'element-ui';

import TUIRoomCore from '../../tui-room-core';
import IconButton from '../common/IconButton.vue';
import AudioSettingTab from '../base/AudioSettingTab.vue';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import AudioIcon from '../base/AudioIcon.vue';
import { WARNING_MESSAGE, MESSAGE_DURATION } from '../../../constants/message';


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioControl',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const { localStream, isDefaultOpenMicrophone, hasStartedMicrophone, isLocalAudioMuted } = storeToRefs(roomStore);
const { isLocalAudioIconDisable, isMuteAllAudio, isAudience } = storeToRefs(basicStore);

const showAudioSettingTab: Ref<boolean> = ref(false);
const audioIconButtonRef = ref<InstanceType<typeof IconButton>>();
const audioSettingRef = ref<InstanceType<typeof AudioSettingTab>>();

watch(isDefaultOpenMicrophone, (val) => {
  roomStore.setIsLocalAudioMuted(!val);
}, { immediate: true });

watch(localStream, (val) => {
  roomStore.setIsLocalAudioMuted(!val.isAudioStreamAvailable);
}, { immediate: true });

function toggleMuteAudio() {
  if (isLocalAudioIconDisable.value) {
    let warningMessage = '';
    if (isMuteAllAudio.value) {
      warningMessage = WARNING_MESSAGE.UNMUTE_LOCAL_MIC_FAIL_MUTE_ALL;
    } else if (isAudience.value) {
      warningMessage = WARNING_MESSAGE.UNMUTE_LOCAL_MIC_FAIL_AUDIENCE;
    }
    Message({
      type: 'warning',
      message: warningMessage,
      duration: MESSAGE_DURATION.NORMAL,
    });
    return;
  }

  roomStore.setIsLocalAudioMuted(!isLocalAudioMuted.value);
  if (!isLocalAudioMuted.value && !hasStartedMicrophone.value) {
    TUIRoomCore.startMicrophone();
    roomStore.setHasStartedMicrophone(true);
    return;
  }
  TUIRoomCore.muteLocalMicrophone(isLocalAudioMuted.value);
  showAudioSettingTab.value = false;
}

function handleMore() {
  if (!showAudioSettingTab.value) {
    showAudioSettingTab.value = true;
  } else {
    showAudioSettingTab.value = false;
  }
}

function handleDocumentClick(event: MouseEvent) {
  if (
    showAudioSettingTab.value
    && !audioIconButtonRef.value?.$el.contains(event.target)
    && !audioSettingRef.value?.$el.contains(event.target)
  ) {
    showAudioSettingTab.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick, true);
});

onUnmounted(() => {
  document.removeEventListener('click', handleDocumentClick, true);
});


return { __sfc: true,basicStore, roomStore, localStream, isDefaultOpenMicrophone, hasStartedMicrophone, isLocalAudioMuted, isLocalAudioIconDisable, isMuteAllAudio, isAudience, showAudioSettingTab, audioIconButtonRef, audioSettingRef, toggleMuteAudio, handleMore, handleDocumentClick, IconButton, AudioSettingTab, AudioIcon }
}

})